import styled from 'styled-components'

export const StyledHistoryList = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StyledHistoryListItem = styled.div`
    display: flex;
    gap: 12px;
    align-items: flex-start;
    padding: 12px 0;
    border-bottom: 1px solid #e6e6e6;

    &:first-child {
        padding-top: 0;
    }
`;

export const StyledHistoryProfileCircle = styled.div`
  min-width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  background-color: #E1E4EA;
`;

export const StyledHistoryAvatar = styled.img`
  min-width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
`;

export const StyledHistoryContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledHistoryHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StyledHistoryUser = styled.span`
  font-weight: 600;
  color: #1a1a1a;
`;

export const StyledHistoryTime = styled.span`
  font-size: 14px;
  color: #8c8c8c;
`;

export const StyledHistoryAction = styled.div`
  font-size: 15px;
  color: #333;
  margin-top: 2px;
`;